import React, { useState } from 'react';
import validator from 'email-validator';
import { useTranslation, withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classNames from 'classnames';
import { useForm } from 'react-hook-form';
import { Label, Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, Textarea, Button, } from '@cargomatic/ui';
import { CircleAlert, LoaderCircle } from 'lucide-react';
import Alert from 'components/ui/Alert';
const SendRateCardEmailModal = ({ show, onHide, onSend, defaultRecipient = '', modalTitle = 'EMAIL_RATE_CARD', }) => {
    var _a, _b;
    const { t } = useTranslation();
    const [isSaving, setIsSaving] = useState(false);
    const { handleSubmit, register, formState: { errors }, } = useForm({
        mode: 'onSubmit',
        reValidateMode: 'onSubmit',
        defaultValues: { emails: defaultRecipient },
    });
    const title = t(modalTitle);
    const emailsLabel = titleize(t('RECIPIENT', { count: 2 }));
    const actionLabel = t('SEND');
    const cancelLabel = t('CANCEL');
    function validateEmails(value) {
        const emailRegex = /\S+@\S+\.\S+/;
        const isValid = value
            .split(',')
            .map((text) => text.trim())
            .every((email) => email && emailRegex.test(email));
        return isValid || t('INVALID_EMAILS');
    }
    async function send(formFields) {
        const { emails } = formFields;
        const to = emails.replace(/' '/g, '').split(',');
        onSend(_.uniq(to));
        onHide();
    }
    function renderError(error) {
        if (!error) {
            return '';
        }
        return React.createElement(Alert, { className: "mb-4", title: error, type: "error" });
    }
    return (React.createElement(Dialog, { open: show, onOpenChange: onHide },
        React.createElement("form", { onSubmit: handleSubmit(send) },
            React.createElement(DialogContent, { className: "sm:max-w-[425px]" },
                React.createElement(DialogHeader, null,
                    React.createElement(DialogTitle, null, title)),
                renderError((_a = errors === null || errors === void 0 ? void 0 : errors.emails) === null || _a === void 0 ? void 0 : _a.message),
                React.createElement("div", { className: classNames({ error: !!errors.emails }) },
                    React.createElement(Label, { className: "mb-2" },
                        emailsLabel,
                        " *"),
                    React.createElement(Textarea, Object.assign({ passEventOnChange: true, error: !!((_b = errors === null || errors === void 0 ? void 0 : errors.emails) === null || _b === void 0 ? void 0 : _b.message), placeholder: t('ENTER_EMAILS_SEPARATED_BY_COMMAS') }, register('emails', {
                        validate: validateEmails,
                        required: t('FIELD_IS_REQUIRED', { field: emailsLabel }),
                    })))),
                React.createElement(DialogFooter, null,
                    React.createElement(Button, { variant: "outline", onClick: onHide, disabled: isSaving }, cancelLabel),
                    React.createElement(Button, { type: "submit", onClick: handleSubmit(send), disabled: isSaving },
                        React.createElement("span", null, actionLabel),
                        isSaving && (React.createElement(LoaderCircle, { className: "w-4 h-4 animate-spin ml-2" }))))))));
};
SendRateCardEmailModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onSend: PropTypes.func.isRequired,
    onHide: PropTypes.func.isRequired,
    defaultRecipient: PropTypes.string,
};
SendRateCardEmailModal.defaultProps = {
    show: false,
    defaultRecipient: [],
};
export default withTranslation()(SendRateCardEmailModal);
